import axios from 'axios';
import {url, superset_domain} from '../../env'

export function getdashboardInfo(paramsObject) {
    return axios.get(`${url}rest-apis-user/dashboard/`, 
    {
      params: paramsObject,
      paramsSerializer: params => {
        return parseParams(params)
      }
    }); 
  }

export function getBookmarkInfo(paramsObject) {
    return axios.get(`${url}rest-apis-user/bookmark/`, 
    {
      params: paramsObject,
      paramsSerializer: params => {
        return parseParams(params)
      }
    }); 
  }

export function getBookmarkGroupers() {
  return axios.get(`${url}rest-apis-user/bookmark-groups/`); 
}

  export function getUserInfo() {
  return axios.get(`${url}rest-apis-user/user-info/`); 
}

// to create/delete the bookmark
export function toggleBookmark(payload) {
  return axios.post(`${url}rest-apis-user/bookmark/`, payload); 
}

// update the bookmark
export function updateBookmark(payload) {
  return axios.put(`${url}rest-apis-user/bookmark/`, payload); 
}

export function toggleFavoriteDashboard(payload) {
  return axios.post(`${url}rest-apis-user/favorite-dashboard/`, payload); 
}

export function supersetLogin(payload) {
  return axios.post(`${superset_domain}api/v1/security/login`, payload); 
}

export function supersetGuestToken(payload, accessToken) {
  return axios.post(`${superset_domain}api/v1/security/guest_token/`, payload,
  {
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    }
  }); 
}

export function favoriteDashboard(paramsObject) {
  return axios.get(`${url}rest-apis-user/favorite-dashboard/`, {
    params: paramsObject
  }); 
}


export function getBookmarkStatus(payload) {
  return axios.post(`${url}rest-apis-user/bookmark/status/`, payload); 
}

export function createBookmarkGrouper(payload) {
  return axios.post(`${url}rest-apis-user/bookmark-groups/`, payload); 
}

export function getStrategyData(params) {
  return axios.get(`${url}notification/status/`, {
    params: params,
    paramsSerializer: params => {
      return parseParams(params)
    }
  }); 
}

export function fetchLeafMenuInfo(params) {
  return axios.get(`${url}rest-apis-user/menu-leaf-info/`, {
    params: params,
    paramsSerializer: params => {
      return parseParams(params)
    }
  }); 
}


  
  
  
function parseParams(params) {
  const keys = Object.keys(params)
  let options = ''

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === 'object'
    const isParamTypeArray = isParamTypeObject && params[key].length >= 0

    if (!isParamTypeObject) {
      options += `${key}=${params[key]}&`
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`
      })
    }
  })

  return options ? options.slice(0, -1) : options
}

